export const SYSTEM_CODE = 'RetailWebSubmission';
export const SYSTEM_GROUP_CODE = 'Rt-Core';
export const SYSTEM_NAME = 'Retail Web Submission';
